module.exports = __webpack_public_path__ + "img/ernst-olga.bbaa4b47.svg";